<ms-highlights-marquee
    *ngIf="!hidden"
    [tiles]="tiles"
    [backgroundContainerConfig]="backgroundContainerConfig"
    [globalLinkConfig]="globalLinkConfig"></ms-highlights-marquee>
